<template>
	<main id="donasi">
		<div v-if="isQurbanTransaction" class="flex justify-end mb-6">
			<vs-button @click.prevent="$router.push('/track-qurban')">
				Lacak Qurban
			</vs-button>
		</div>
		<section 
			v-for="(item, i) in histories"
			:key="i"
		>

			<vx-card class=" mb-6 py-4 px-3">
				<header class="mb-4 flex items-center">
					<div class="flex flex-col md:flex-row">
						<small class="block text-grey mr-4">
							<strong>{{ item.jenis_pembayaran ? capitalize(item.jenis_pembayaran.name) : '-' }}</strong>
						</small>
						<small class="block mr-4">
							<strong v-if="item.metode_pembayaran && !['gopay', 'ID_DANA', 'ID_LINKAJA'].includes(item.metode_pembayaran.code)" class="mb-2 text-danger">#{{item.no_pembayaran}}</strong>
						</small>
					</div>
					<div>
						<vs-chip v-if="item.status == 1" color="warning">Pending</vs-chip>
						<vs-chip v-if="item.status == 2" color="success">Sukses</vs-chip>
						<vs-chip v-if="item.status == 3" color="danger">Batal</vs-chip>
					</div>
				</header>
				<main class="flex items-center flex-col md:flex-row mb-2">

					<div class="mr-4 mb-4 md:mb-0">
						<img src="/assets/images/profile/transaction/donasi.png" class="w-16 md:w-12" alt="" />
					</div>
					<div class="flex items-center flex-col md:flex-row justify-between w-full">
						<main class="mb-4 md:mb-0">
							<!-- PPOB -->
							<h5 
								class="mb-2 text-center md:text-left" 
								v-if="item.jenis_pembayaran && ['CAMPAIGN', 'PPOB', 'QURBAN'].includes(item.jenis_pembayaran.name)"
							>
								<strong v-if="item.metode_pembayaran">
									{{ item.transaksi_terkait ? item.transaksi_terkait : '-' }}
								</strong>
							</h5>

							<!-- Campaign -->
							<h5 class="mb-2 text-center md:text-left" 
								v-else-if="item.jenis_pembayaran &&
								item.jenis_pembayaran.name == 'CAMPAIGN'">
								<strong v-if="item.name !== null">
									{{ capitalize(item.jenis_pembayaran.name.toLowerCase()) }} - {{item.name}}
								</strong>
								<i v-else>
									{{item.jenis_pembayaran.name}}
								</i>
							</h5>

							<!-- / -->
							<h5 class="mb-2 text-center md:text-left" v-else>
								<strong v-if="item.name !== null">
									{{item.name}}
								</strong>
								<i v-else>
									{{ item.jenis_pembayaran.name }}
								</i>
							</h5>
							<p class="text-dark text-center md:text-left">
								{{ item.time }}
							</p>
						</main>
						<div>
							<small class="mb-2">Total Harga</small>
							<h5 class="mb-6">
								<strong>{{ item.jumlah_bayar ? 'Rp ' + formatRupiah(item.jumlah_bayar) : '' }}</strong>
							</h5>
						</div>
					</div>
				</main>
			</vx-card>
		</section>
		<section v-if="errorMessage">
			<vs-alert color="danger">
				{{errorMessage}}
			</vs-alert>
		</section>
		<div class="flex justify-center">
			<div v-for="(item, i) in numPagination" :key="i">
				<vs-button type="border" @click.prevent="changePage(i + 1)" class="rounded-none" size="small">
					{{item}}
				</vs-button>
			</div>
		</div>
		<!-- Modal -->
		<vs-popup fullscreen title="Detail Transaksi" :active.sync="showDetailPopup">
			<div class="vx-row">
				<div class="vx-col w-full md:w-2/3">
					<!--  -->
					<vx-card style="box-shadow: none;border: 1px solid #ccc;" class="mb-4">
						<div class="flex flex-col md:flex-row items-center justify-between mb-2">
							<p><strong class="text-dark">Status</strong></p>
							<p><strong :class="getStatus(detail.status).class">{{ getStatus(detail.status).label }}</strong></p>
						</div>
						<div v-if="detail.metode_pembayaran && !['gopay', 'ID_DANA', 'ID_LINKAJA'].includes(detail.metode_pembayaran.code)" class="flex flex-col md:flex-row items-center justify-between mb-2">
							<p><span class="text-grey">No. Pembayaran</span></p>
							<span class="mb-2">{{detail.no_pembayaran}}</span>
						</div>
						<div class="flex flex-col md:flex-row items-center justify-between mb-2">
							<p><span class="text-grey">Tanggal Pembayaran</span></p>
							<p>{{detail.time}}</p>
						</div>
					</vx-card>
					<!-- / -->
					<!--  -->
					<vx-card style="box-shadow: none;border: 1px solid #ccc;" class="mb-4">
						<h5><strong>Detail Qurban</strong></h5>
						<vs-divider></vs-divider>
						<div class="flex flex-col mb-4">
							<p class="mb-2"><strong>Qurban</strong></p>
							<p>{{ detail.transaksi_terkait ? detail.transaksi_terkait : '-' }}</p>
						</div>
						<div v-if="detail.name">
							<ul >
								<li>
									<strong>Mudhohi</strong>
								</li>
								<li v-for="(item, i) in detail.name.split(',')" :key="i">
									{{ (i + 1) + '. ' + item }}
								</li>
							</ul>
						</div>
					</vx-card>
					<!-- / -->
				</div>
				<div class="vx-col w-full md:w-1/3" style="background: #f7f7f7;">
					<progress-qurban :reports="reports" />
				</div>
			</div>
		</vs-popup>
		<!-- / -->
	</main>
</template>
<script>
	import { mapState } from 'vuex';
	import { qurbanCode } from '@/assets/utils/qurban';

	export default {
		components: {
			ProgressQurban: () => import('./ProfileQurbanProgress.vue')
		},
		data: () => ({
			jenis_id: null,
			type: null,
			showDetailPopup: false,
			histories: [],
			length: 5,
			start: 0,
			numPagination: 0,
			detail: {},
			reports: [],
			errorMessage: null,
			jenisTransaksi: null
		}),
		watch: {
			start(val) {
				this.getHistory();
			}
		},
		computed: {
			isQurbanTransaction() {
				if(this.jenisTransaksi) {
					return this.jenisTransaksi.name.toLowerCase() == qurbanCode;
				}

				return false;
			},
			...mapState('auth', ['profile'])
		},
		created() {
			this.getTypeTransaction()
		},
		methods: {
			changePage(index) {
				this.start = (index - 1) * this.length;
			},
			getStatus(status) {
				if(status == 1) {
					return {
						label: 'Pending',
						class: 'text-warning'
					};
				}
				else if(status == 2) {
					return {
						label: 'Sukses',
						class: 'text-success'
					};
				}
				else {
					return {
						label: 'Batal',
						class: 'text-danger'
					};
				}
			},
			showDetail(item) {
				this.detail = item;
				this.showDetailPopup = true;
			},
			viewQurbanProgress(item) {
				this.$emit('viewQurbanProgress', item);
			},
			getHistory() {
				this.$vs.loading({
					container: '#donasi'
				})
				this.$store.dispatch('transaction/getHistory', {
					jenis_id: this.jenis_id,
					user_id: this.profile.id,
					length: this.length,
					start: this.start,
					ord: 'desc'
				})
				.then(payload => {
					this.$vs.loading.close('#donasi > .con-vs-loading')
					payload.data.map(item => {
						const arr = item.created_at.split('.'),
							dateTime = arr[0].split('T');
						item.time = dateTime.join(' ');
					})
					this.histories = payload.data;
					this.numPagination = Math.ceil( payload.recordsTotal / this.length );
				})
				.catch(e => {
					this.$vs.loading.close('#donasi > .con-vs-loading');
					console.error(e);
					if(
						e.response && 
						e.response.data &&
						e.response.data.message
					) {
						this.errorMessage = e.response.data.message;						
					}
					return false;
				})
			},
			getTypeTransaction() {
				// get type transaction via state
				this.$store.dispatch('transaction/getTypeTransaction')
				.then(data => {
					let find = null;
					if(this.$store.state.transactionType === 'zis') {
						let datas = data.filter(it => ['zakat', 'infaq', 'sedekah'].includes(it.name.toLowerCase()));

						find = datas.length > 0 ? datas.map(it => it.id).join(',') : 1;
						this.jenis_id = find;
					}
					else {
						find = data.find(it => it.name.toLowerCase() == this.$store.state.transactionType);
						this.jenis_id = find ? find.id : 1;
					}

					this.jenisTransaksi = find;
					
					
					this.getHistory();
				})
				.catch(e => {
					console.error(e);
					return false;
				});
			}
		}
	};
</script>